import { Trash2 } from 'lucide-react';

interface RemoveRowButtonProps {
  label: string; // accessible name and tooltip, e.g. "Remove region 2"
  onClick: () => void;
  disabled?: boolean; // the row's record cannot be removed (already gone, or managed elsewhere)
  testId?: string;
}

/** The one action on a row the operator added in place — a bare trash icon, not a `⋮` menu (DESIGN.md §4.6). */
export function RemoveRowButton({ label, onClick, disabled, testId }: RemoveRowButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className="inline-flex h-11 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 hover:text-error-600 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-gray-500 focus-ring dark:text-gray-400 dark:hover:bg-gray-800"
    >
      <Trash2 className="size-4" aria-hidden="true" />
    </button>
  );
}
